import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Grid,
  Container,
  Card,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import List from "../../components/shared/List";
import Dialog from "../../components/shared/Dialog";
import { useDispatch } from "react-redux";
import Dropdown from "../../components/shared/DropDown";
import Iconify from "../../components/iconify/iconify";
import { color } from "../../utils/constant";

import {
  getDoctorList,
  getPaginationInfo,
  getUserMasterList,
} from "../../data/selectors/User_Master/user_Master.selector";
import useUserMaster from "../../data/talons/User_Master/useUser_Master";
import { resetUserMaster } from "../../data/reducers/User_Master/user_MasterForm.reducer";
import UserMasterForm from "./User_MasterForm";
import { useUserMasterForm } from "../../data/talons/User_Master/useUser_MasterForm";
import RHFAutocomplete from "../../components/shared/RHFAutocomplete";
import { useForm } from "react-hook-form";
/**
 * Render Category screen with list of data
 * data will taken from the selector
 *
 */
export default function UserMaster() {
  const [showDialog, setShowDialog] = useState(false);
  const [Open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [editId, setEditId] = useState(null);
  const UserMasterList = useSelector(getUserMasterList);
  const paginationInfo = useSelector(getPaginationInfo);
  const doctorList = useSelector(getDoctorList);
  const { setValue, control } = useForm();

  const dispatch = useDispatch();
  const {
    gridHeaders,
    loading,
    loader,
    status,
    StatusList,
    handleStatusChange,
    fetchUserMasterList,
    DoctorId,
    findDoctorFromLabel,
    fetchDoctorComboList,
  } = useUserMaster();

  const { getUserMasterbyId } = useUserMasterForm({});

  useEffect(() => {
    fetchUserMasterList({
      current_page: 1,
      row_count: rowsPerPage,
    });
    fetchDoctorComboList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  const onSubmit = useCallback(
    async (e) => {
      e?.preventDefault();
      await fetchUserMasterList({
        current_page: 1,
        row_count: rowsPerPage,
      });
    },
    [fetchUserMasterList, rowsPerPage]
  );

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        mt: 1,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2}>
          <RHFAutocomplete
            borderRadius={"12px"}
            name="name"
            label="Doctor Name"
            disabled={editId ? true : false}
            freeSolo
            data={doctorList || []}
            defaultValue={DoctorId}
            onInputChange={(value) => findDoctorFromLabel(value)}
            id={doctorList?.map((option) => option.id)}
            renderOption={(props, option) => (
              <>
                <li {...props} key={option}>
                  {option}
                </li>
              </>
            )}
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option}
                  label={option}
                  size="small"
                  color="info"
                  variant="soft"
                />
              ))
            }
            control={control}
            setValue={setValue}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Dropdown
            size={"small"}
            title={"Status"}
            data={StatusList}
            handleDropdownChange={handleStatusChange}
            dropdownValue={status}
            allReqired={true}
            allStatusVal="0"
          />
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-right"
          item
          xs={6}
          sm={3}
          md={2}
        >
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{
              maxHeight: 40,
              backgroundColor: color.button,
              borderRadius: 3,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
          >
            Get Data
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          md={2}
          sx={{ marginLeft: "auto", textAlign: "end" }}
        >
          <Button
            sx={{
              height: 40,
              borderRadius: 3,
              backgroundColor: color.button,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
            onClick={() => setShowDialog(true)}
            variant="contained"
            startIcon={<Iconify icon="mingcute:add-line" />}
          >
            {"New"}
          </Button>
          <Dialog
            handleClose={() => {
              setShowDialog(false);
              setEditId(null);
              dispatch(resetUserMaster());
              fetchUserMasterList({ current_page: 1, row_count: rowsPerPage });
            }}
            open={showDialog}
            fullWidth={true}
          >
            <UserMasterForm
              postSubmit={async () => {
                setShowDialog(false);
                setEditId(null);
                await fetchUserMasterList({
                  current_page: 1,
                  row_count: rowsPerPage,
                });
                dispatch(resetUserMaster());
              }}
              editId={editId}
            />
          </Dialog>
        </Grid>
      </Grid>
      <Card
        sx={{
          flexGrow: { md: 1 },
          display: { md: "flex" },
          flexDirection: { md: "column" },
          my: "12px",
          borderRadius: "12px",
          boxShadow:
            "0 0 2px 0 rgba(145, 158, 171, 0.2),0 12px 24px -4px rgba(145, 158, 171, 0.12)",
        }}
      >
        <List
          loading={loading}
          data={UserMasterList}
          paginationData={paginationInfo}
          columnsData={gridHeaders}
          getRowId={(row) => row.id}
          autoHeight={true}
          pageCount={Number(paginationInfo.total_page)}
          totalRecords={paginationInfo.total_count}
          onPageChange={async (page, rowsPerPage) => {
            setRowsPerPage(rowsPerPage);
            await fetchUserMasterList({
              current_page: page,
              row_count: rowsPerPage,
            });
          }}
          enableEdit
          onEditIconPress={async (id) => {
            await getUserMasterbyId(id);
            setEditId(id);
            setShowDialog(true);
          }}
        />
      </Card>
    </Container>
  );
}
